"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderRadius = void 0;
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */
const borderRadius = {
  roundedNone: 0,
  roundedSmall: 4,
  rounded: 8,
  roundedMedium: 12,
  roundedLarge: 16,
  roundedXLarge: 24,
  roundedFull: 1000
};
exports.borderRadius = borderRadius;